import React from "react";
import { useTranslation } from "react-i18next";
import { useModal } from "src/hooks/useModal";
import { LoginPopup } from "src/page-components/auth/LoginPopup";
import { PasswordResetPopup } from "src/page-components/auth/PasswordResetPopup";
import { PasswordUpdatePopup } from "src/page-components/auth/PasswordUpdatePopup";
import { PasswordUpdatedPopup } from "src/page-components/auth/PasswordUpdatedPopup";
import { PATHNAMES } from "src/constants/routes";
import { useQueryParams } from "src/hooks/useQueryParams";
import { EmailConfirmPopup } from "src/page-components/auth/EmailConfirmPopup";
import { EmailConfirmFailPopup } from "src/page-components/auth/EmailConfirmFailPopup";
import {
  IS_ACTIVE_UPDATE_PASSWORD_KEY,
  IS_EMAIL_CONFIRM_KEY,
  TRUE,
  FALSE,
} from "./constants";
import { authButtonsTrns } from "./trns";
import { Button } from "../Button";
import { Link } from "../Link";

export const AuthButtons = () => {
  const { t } = useTranslation();
  const { getQueryParam } = useQueryParams();

  const isUpdatePasswordStr = getQueryParam(IS_ACTIVE_UPDATE_PASSWORD_KEY);
  const isEmailConfirmStr = getQueryParam(IS_EMAIL_CONFIRM_KEY);

  const isUpdatePassword = isUpdatePasswordStr === TRUE;
  const isEmailConfirmSuccess = isEmailConfirmStr === TRUE;
  const isEmailConfirmFail = isEmailConfirmStr === FALSE;

  const emailConfirmFailModal = useModal(isEmailConfirmFail);
  const emailConfirmPopupModal = useModal(isEmailConfirmSuccess);
  const loginModal = useModal();
  const passwordResetModal = useModal();
  const passwordUpdateModal = useModal(isUpdatePassword);
  const passwordUpdatedModal = useModal();

  return (
    <div className="flex justify-center items-center gap-10 h-full text-xl">
      <Button className="font-bold h-full" onClick={loginModal.openModal}>
        {t(authButtonsTrns.loginButton)}
      </Button>
      <Link href={PATHNAMES.REGISTRATION}>
        <Button>{t(authButtonsTrns.signUpButton)}</Button>
      </Link>

      <EmailConfirmFailPopup {...emailConfirmFailModal} />
      <EmailConfirmPopup {...emailConfirmPopupModal} />
      <LoginPopup
        {...loginModal}
        onOpenPasswordResetPopup={passwordResetModal.openModal}
      />
      <PasswordResetPopup {...passwordResetModal} />
      <PasswordUpdatePopup
        {...passwordUpdateModal}
        onOpenPasswordUpdatedPopup={passwordUpdatedModal.openModal}
      />
      <PasswordUpdatedPopup {...passwordUpdatedModal} />
    </div>
  );
};
